<div class="health-right">
	<div class="health-category">
		RTB <span [class]="itemHealth?.Foreground('rtb')">●</span>
	</div>
	<div class="health-category">
		FDM <span [class]="itemHealth?.Foreground('fdm')">●</span>
	</div>
	<div class="health-category">
		MD <span [class]="itemHealth?.Foreground('md')">●</span>
	</div>
</div>